
export default {
  name: 'PagesAboutExtentionsCompanys',
  data() {
    return {
      filter: 'ALL',
      companys: [],
      countAllCompanys: 0,
      companysLimit: 12,
      companysOffet: 0,
      streams: [],
      countAllStreams: 0,
      streamsLimit: 4,
      streamsOffset: 0,
    }
  },
  async fetch() {
    await Promise.all([this.fetchCompanys(), this.fetchStreams()])
  },
  watch: {
    filter() {
      this.companys = []
      this.companysOffet = 0
      this.fetchCompanys()
    },
  },

  methods: {
    async fetchCompanys() {
      const { authors, countAllAuthors } = await this.$axios.$get(
        '/companys/about',
        {
          params: {
            limit: this.companysLimit,
            offset: this.companysOffet,
            filter: this.filter,
            type: 'COMPANY',
          },
        }
      )

      this.countAllCompanys = countAllAuthors

      if (this.companys?.length) {
        this.companys = this.companys.concat(authors)
      } else {
        this.companys = authors
      }
    },
    async fetchStreams() {
      const { streams, countAllStreams } = await this.$axios.$get(
        '/streams/navigator',
        {
          params: {
            limit: this.streamsLimit,
            offset: this.streamsOffset,
            searchString: this.searchString,
          },
        }
      )

      if (this.streams?.length) {
        this.streams = this.streams.concat(streams)
      } else {
        this.streams = streams
      }
      this.streamsCount = countAllStreams
    },

    loadMore() {
      this.companysOffet = this.companysOffet + this.companysLimit
      this.fetchCompanys()
    },
    loadMoreStreams() {
      this.streamsOffset = this.streamsOffset + this.streamsLimit
      this.fetchStreams()
    },
  },
}
